import { constants } from "../constants";

export const DEFAULT_STATE = {
  monthlyStatements: []
};

const var1 = (state = DEFAULT_STATE, { type, payload } = {}) => {
  switch (type) {
    case constants.STATEMENTS_INFO:
      return {
        ...state,
        monthlyStatements: [...payload]
      };
    default:
      return state;
  }
};

export default var1;
